import React, { ReactNode } from "react";
import { setDropzoneRef } from "@lib/dropzoneRef";
import { LogoUploadContextValue, useLogoUpload } from "./logoUpload.context";

interface Props {
    children: ReactNode | ((open: LogoUploadContextValue["open"]) => ReactNode);
}

export const LogoUpload: React.FC<Props> = ({ children }) => {
    const { open, inputProps } = useLogoUpload();

    return (
        <>
            {typeof children === "function" ? children(open) : children}
            <input
                {...inputProps}
                className="d-none"
                data-testid="logo-upload-input"
                ref={(el) => setDropzoneRef(inputProps, el)}
            />
        </>
    );
};
